import React, { useMemo } from 'react';
import _sortBy from 'lodash/sortBy';

import {
    ChartOrEmptyMessage,
    DetectionCountPerChannel,
    LoadingSpinner,
} from '@trqk/components';

import { chartHeight } from './constants';

interface Props {
    detections: BmatDetection[];
    loading: boolean;
    maxSize: number;
}

export const DetectionsBySourceChart = ({
    detections,
    loading,
    maxSize,
}: Props): JSX.Element => {
    let detectionCountsByChannel = useMemo(() => {
        const channelCountsMap = detections.reduce(
            (
                acc: Record<string, number>,
                { channel }: BmatDetection,
            ): Record<string, number> => {
                if (channel) {
                    const currentCount = acc?.[channel] ?? 0;

                    acc[channel] = currentCount + 1;
                }

                return acc;
            },
            {},
        );

        const detectionCountsByChannelUnsorted = Object.entries(
            channelCountsMap,
        ).map(
            ([channel, detectionCount]): DetectionCountByChannel => ({
                channel,
                detectionCount,
            }),
        );

        return _sortBy(detectionCountsByChannelUnsorted, 'detectionCount');
    }, [detections]);

    detectionCountsByChannel = detectionCountsByChannel.slice(0, maxSize);

    return (
        <>
            {loading && (
                <div
                    className="flex items-center justify-center w-full"
                    style={{ height: chartHeight }}
                >
                    <LoadingSpinner />
                </div>
            )}
            {!loading && (
                <ChartOrEmptyMessage
                    data={detectionCountsByChannel}
                    height={chartHeight}
                >
                    <DetectionCountPerChannel
                        data={detectionCountsByChannel}
                        height={chartHeight}
                        chartDivId="detections-by-station-name-bar-chart"
                    />
                </ChartOrEmptyMessage>
            )}
        </>
    );
};
